const baseConfig = require('./base.json');
const prodConfig = require('./prod.json');

const getConfig = () => {
	// if (process.env.REACT_APP_NODE_ENV === 'production') {
	// 	return Object.assign({}, baseConfig, prodConfig);
	// }
	// return baseConfig;
	return Object.assign({}, baseConfig, prodConfig);
};

export default getConfig;